export const DislikedItemTypes = [
    "DISLIKED_NORMTITLE",
    "DISLIKED_COMPANY_SECTOR",
    "DISLIKED_OCCUPATION_CATEGORY",
    "DISLIKED_EXTRACTED_PAY",
    "DISLIKED_COMPANY_NAME",
    "DISLIKED_JOBTYPE",
    "DISLIKED_CITY",
    "DISLIKED_STATE",
    "DISLIKED_POSTAL_CODE",
    "DISLIKED_IQ_REQUIREMENT",
    "NOT_LOOKING",
    "DOESNT_WANT_REMOTE",
    // job qualifications
    "DOESNT_HAVE_CERTIFICATION",
    "DOESNT_HAVE_LICENSE",
    "DOESNT_HAVE_SKILL",
    "DOESNT_KNOW_LANGUAGE",
    "DOESNT_HAVE_EDUCATION",
    "OTHER",
] as const

export type DislikedItemType = (typeof DislikedItemTypes)[number]
export type DislikedItem = { type: DislikedItemType; payload?: string }

export const PreferenceCategories = [
    "JOB_TITLE",
    "JOB_TYPE",
    "SCHEDULE",
    "PAY",
    "LOCATION",
    "REMOTE",
    "COMPANY",
    "JOB_CATEGORY",
    "LANGUAGE",
    "EDUCATION",
    "CERTIFICATION",
    "LICENSE",
    "SKILL",
] as const
export type IPreferenceCategory = (typeof PreferenceCategories)[number]

export type IDisplayItem = ReturnType<typeof DisplayItem>
export type IMultiSelectDisplayItem = ReturnType<typeof MultiSelectDisplayItem>
export type IAdditionalSelection = { key: string; displayText: string; selected: boolean }
export type MultiSelectOpts = {
    additionalSelections: IAdditionalSelection[]
    additionalSelectionsLabel: string
}

export const DisplayItem = (p: {
    key: string
    iconCategory: IPreferenceCategory
    field: DislikedItemType | "multiselect-location"
    value?: string
    unselectedText: string
    selectedText: string
    selected: boolean
    isDisplayed: boolean
}) => p

export const MultiSelectDisplayItem = (p: IDisplayItem & MultiSelectOpts) => ({ ...p, isMultiSelect: true })

export function isMultiSelectDisplayItem(item: IDisplayItem | IMultiSelectDisplayItem): item is IMultiSelectDisplayItem {
    return item.field.startsWith("multiselect-")
}
